import { sendGet } from "./axios";

export const getListActivityLog = (params) =>
  sendGet("/activity-log", params);
